import React from 'react';

import AccessoriesCategory from '@features/filter/v1/core/AccessoriesCategory';
import AccountManager from '@features/filter/v1/core/AccountManager';
import AdminUsers from '@features/filter/v1/core/AdminUsers';
import Brand from '@features/filter/v1/core/Brand';
import BuyerETD from '@features/filter/v1/core/BuyerETD';
import CollectionMember from '@features/filter/v1/core/CollectionMember';
import CreatedBy from '@features/filter/v1/core/CreatedBy';
import DateRangeFilter from '@features/filter/v1/core/DateRangeFilter';
import FabricType from '@features/filter/v1/core/FabricType';
import Market from '@features/filter/v1/core/Market';
import Status from '@features/filter/v1/core/Status';
import SubCategory from '@features/filter/v1/core/SubCategory';
import Season from '@features/filter/v1/core/Season';
import MaterialType from '@features/filter/v1/core/MaterialType';
import PersonWiseCollection from '@features/filter/v1/core/PersonWiseCollection';
import ProjectManager from '@features/filter/v1/core/ProjectManager';
import Merchandiser from '@features/filter/v1/core/Merchandiser';
import PoReceivedDate from '@features/filter/v1/core/PoReceivedDate';
import OrderStyleNumber from '@features/filter/v1/core/OrderStyleNumbers';
import OrderPONumber from '@features/filter/v1/core/OrderPONumbers';
import OrderTitle from '@features/filter/v1/core/OrderTitle';
import Factory from '@features/filter/v1/core/Factory';
import SalesContract from '@features/filter/v1/core/SalesContract';
import OrderStage from '@features/filter/v1/core/OrderStage';
import TnaStatus from '@features/filter/v1/core/TnaStatus';
import Composition from '@features/filter/v1/core/Composition';
import GSM from '@features/filter/v1/core/GSM';
import FabricSubCategory from '@features/filter/v1/core/FabricSubCategory';
import FabricCategory from '@features/filter/v1/core/FabricCategory';
import Email from '@features/filter/v1/core/Email';
import Role from '@features/filter/v1/core/Role';
import Department from '@features/filter/v1/core/Department';
import TrimsCategory from '@features/filter/v1/core/TrimsCategory';
import TrimsComposition from '@features/filter/v1/core/TrimsComposition';
import TrimsType from '@features/filter/v1/core/TrimsType';
import WashProcess from '@features/filter/v1/core/WashProcess';
import EmbellishmentCategory from '@features/filter/v1/core/EmbellishmentCategory';
import IsNitexStyles from '@features/filter/v1/core/IsNitexStyles';
import CountryList from '@features/filter/v1/core/CountryList';
import CollectionStatus from '@features/filter/v1/core/CollectionStatus';
import FilterCollectionStatus from '@features/filter/v1/core/FilterCollectionStatus';
import FilterDesignStatus from '@features/filter/v1/core/FilterDesignStatus';
import SalesChannel from '@features/filter/v1/core/SalesChannel';

import { checkAnyUserType } from '@utils/Util';

const FilterComponent = ({ fields, showFilter, processName, activeTab, pathName }) => {
	return (
		<div
			className={
				showFilter
					? 'filter-bar-section custom-scrollbar open'
					: 'filter-bar-section custom-scrollbar'
			}
		>
			<div className="filter-content">
				<div>
					{/* {fields.roleBasedCollection && <RoleWiseCollection />} */}
					{/* {fields.criteriaList && <Criteria />} */}
					{pathName !== '/nitex-studio' && fields.filterCategory && (
						<Status processName={processName} />
					)}
					{fields.status &&
						activeTab === 'Development' &&
						pathName !== '/nitex-studio' &&
						checkAnyUserType(['ADMIN', 'FASHION_DESIGNER']) && (
							<CollectionStatus processName={processName} />
						)}
					<div id="accordion">
						{fields.filterCollectionStatus && <FilterCollectionStatus />}
						{fields.filterDesignStatus && <FilterDesignStatus />}
						{fields.category && <SubCategory />}
						{fields.market && <Market />}
						{/* {fields.collection && <Collections />} */}
						{fields.personWiseCollection && <PersonWiseCollection />}
						{fields.brand && <Brand />}
						{fields.season && <Season />}
						{fields.dateRange && <DateRangeFilter />}
						{fields.publishDateRange && <DateRangeFilter rangeType="publishDate" />}
						{fields.owner && <CreatedBy />}
						{fields.collectionMember && <CollectionMember />}
						{fields.styleNumber && <OrderStyleNumber />}
						{fields.tnaStatus && <TnaStatus />}
						{fields.salesChannel && <SalesChannel />}
						{fields.fabricType && <FabricType />}
						{fields.materialType && <MaterialType />}
						{fields.fabricCategory && <FabricCategory />}
						{fields.trimsCategories && <TrimsCategory />}
						{fields.accessoriesCategory && <AccessoriesCategory />}
						{fields.embellishmentCategory && <EmbellishmentCategory />}
						{fields.fabricSubCategory && <FabricSubCategory />}
						{fields.itemType && <TrimsType />}
						{fields.washProcesses && <WashProcess />}
						{fields.composition && <Composition />}
						{fields.trimsComposition && <TrimsComposition />}
						{fields.gsm && <GSM />}
						{/* {fields.personWiseCollection && <PersonWiseCollection processName={processName} />} */}
						{fields.accountManager && <AccountManager />}
						{fields.projectManager && <ProjectManager />}
						{fields.nitexDesign && <IsNitexStyles />}
						{fields.merchandiser && <Merchandiser />}
						{fields.poNumber && <OrderPONumber />}
						{fields.poReceivedDate && <PoReceivedDate />}
						{fields.buyerEtd && <BuyerETD />}
						{fields.orderTitle && <OrderTitle />}
						{fields.orderStage && <OrderStage />}
						{fields.factory && <Factory />}
						{fields.salesContract && <SalesContract />}
						{fields.email && <Email />}
						{fields.role && <Role />}
						{fields.department && <Department />}
						{fields.teamLead && (
							<AdminUsers
								title="Team lead"
								fieldName="teamLeads"
								itemVarName="teamLeadUser"
								accordionId="teamLead"
							/>
						)}
						{fields.teamMember && (
							<AdminUsers
								title="Team member"
								fieldName="teamMembers"
								itemVarName="teamMemberUser"
								accordionId="teamMember"
							/>
						)}
						{fields.country && <CountryList />}
						{/*{fields.crmMyTeam && <CRMTeamMembers />}*/}
					</div>
				</div>
			</div>
		</div>
	);
};

export default FilterComponent;
